import { useQuery } from "@tanstack/react-query";
import {
  getTotalActiveUsers,
  getTotalInactiveUsers,
  getTotalUsers,
} from "services/users.service";

export const useUserStats = () => {
  const { data: total, isLoading: isTotalLoading } = useQuery({
    queryKey: ["totalUsers"],
    queryFn: getTotalUsers,
  });

  const { data: active, isLoading: isActiveLoading } = useQuery({
    queryKey: ["activeUsers"],
    queryFn: getTotalActiveUsers,
  });

  const { data: inactive, isLoading: isInactiveLoading } = useQuery({
    queryKey: ["inactiveUsers"],
    queryFn: getTotalInactiveUsers,
  });

  return {
    totalRegisteredUsers: total ?? null,
    activeUsers: active ?? null,
    inActiveUsers: inactive ?? null,
    isLoading: isTotalLoading || isActiveLoading || isInactiveLoading,
  };
};